import React from "react";
import { useNavigate } from "react-router-dom";

const NaboraExhibitions = ({ data }) => {
  const navigate = useNavigate();

  const defaultData = {
    title: "Nabora Monthly Exhibitions",
    subtitle:
      "Hybrid online discovery driving offline neighbourhood exhibitions.",
    currentPeriod: "Q3: 2026",
    exhibitions: [
      {
        emoji: "🥫",
        title: "FMCG & Food Festival",
        date: "July 1 - July 31",
        participants: "120+ Merchants",
        sector: "Food & Daily Essentials",
      },
      {
        emoji: "👗",
        title: "Fashion & Lifestyle Expo",
        date: "August 1 - August 31",
        participants: "90+ Brands",
        sector: "Fashion & Lifestyle",
      },
      {
        emoji: "🧺",
        title: "Local Crafts Showcase",
        date: "September 1 - September 30",
        participants: "75+ Makers",
        sector: "Handmade & Crafts",
      },
    ],
  };

  const content = data || defaultData;

  return (
    <div className="min-h-screen bg-slate-950 text-white">
      <div className="py-8 px-6 bg-gradient-to-br from-violet-950 via-purple-950 to-slate-950">
        <div className="max-w-5xl mx-auto text-center">
          <div className="uppercase tracking-[4px] text-yellow-300 text-sm mb-4">
            🎪 NABORA EXHIBITIONS
          </div>

          <h1 className="text-2xl lg:text-4xl font-bold mb-4">
            {content.title}
          </h1>

          <p className="text-slate-300 text-base lg:text-xl">
            {content.subtitle}
          </p>

          <div className="mt-5 inline-flex px-5 py-2 rounded-full bg-white/10 border border-white/20 text-cyan-300">
            {content.currentPeriod}
          </div>
        </div>
      </div>

      <div className="py-8 px-6">
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {content.exhibitions.map((item, index) => (
              <div
                key={index}
                className="bg-slate-900/80 rounded-3xl p-6 border border-white/10 hover:border-purple-400/50 transition-all"
              >
                <div className="text-5xl mb-4">{item.emoji}</div>

                <h2 className="text-lg lg:text-xl font-bold text-white mb-3">
                  {item.title}
                </h2>

                <div className="space-y-2 text-sm text-slate-300">
                  <div>📅 {item.date}</div>

                  <div>👥 {item.participants}</div>

                  <div>🏷️ {item.sector}</div>
                </div>

                <button
                  onClick={() => navigate(`/nabora/exhibition/${index}`)}
                  className="mt-5 w-full px-4 py-2 rounded-xl bg-gradient-to-r from-fuchsia-500 to-violet-600 font-semibold hover:scale-105 transition-all"
                >
                  Explore Exhibition →
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="py-8 px-6 bg-gradient-to-br from-slate-900 to-violet-950">
        <div className="max-w-4xl mx-auto text-center">
          <div className="text-4xl mb-3">🌍</div>

          <h2 className="text-cyan-200 text-xl lg:text-3xl font-bold mb-3">
            Every neighbourhood can host its own digital festival
          </h2>

          <p className="text-slate-300 mb-6">
            Merchants, organisers, creators and customers come together through
            Nabora exhibitions.
          </p>

          <button
            onClick={() => navigate("/nabora/organiser")}
            className="px-6 py-3 rounded-xl border border-white/30 hover:bg-white/10 transition-all"
          >
            Become Exhibition Organiser
          </button>
        </div>
      </div>
    </div>
  );
};

export default NaboraExhibitions;
